import React, { useCallback, useEffect, useState } from 'react';
import {
  Typography,
  Checkbox,
  Stack,
} from "@mui/material";
import { useRouter } from "next/router";
import FavoriteBorder from "@mui/icons-material/FavoriteBorder";
import Favorite from "@mui/icons-material/Favorite";

import { FavoriteButton, UnFavoriteButton } from "../../api/product";
import * as Apifav from "../../api/favorite";
import { isProduction } from '@/config';
import { checkLoginStatus } from '@/utils/authen';
import { saveRedirectPath } from '@/utils/sessionRedirect';

interface FavoriteButtonProps {
  initialFavoriteCount: number;
  getToken: string;
  productId: number;
  productItems: any[];
  disableLabel: boolean;
}


const MyFavoriteButton: React.FC<any> = ({ 
  initialFavoriteCount, getToken, productId, disableLabel, productItems,
 }) => {

    
  const [isFavorite, setIsFavorite] = useState(false);
  const [favoriteCount, setFavoriteCount] = useState(initialFavoriteCount);
  const [textLabel, setDisableLabel] = useState(disableLabel);

  const router = useRouter();

  const GetProductFavorite = async () =>  {
    const resFav = await Apifav.GetProductFavorite(getToken);

    if (resFav?.success) {
      for (let i = 0; i < resFav?.data.length; i++) {
        if (resFav.data[i].product_id == productId) {
          setIsFavorite(true);
        }
      }
    } else {

    }

  }
  
  // const handleFavoriteToggle = async () => {
  //   if (!getToken) {
  //     router.push('/account/signin'); 
  //   }
  
  //   try {
     
  //     if (isFavorite) {
  //       const response = await UnFavoriteButton(productId, getToken);
  //       // console.log(response,"UnFavoriteButton");
  //       setIsFavorite(false); 
  //       setFavoriteCount(favoriteCount - 1);
  //     } else {
      
  //       const response = await FavoriteButton(productId, getToken);
  //       // console.log(response,"FavoriteButton");
  //       setIsFavorite(true);
  //       setFavoriteCount(favoriteCount + 1);
  //     }
     
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  const handleFavoriteToggle = useCallback(async () => {

    saveRedirectPath();

    if (!isLoggedIn) {
        router.push(`/account/signin`);
        return; 
    }

    try {
      if (isFavorite) {
        await UnFavoriteButton(productId.toString(), getToken);
        setIsFavorite(false);
        setFavoriteCount((count:any) => Math.max(0, count - 1));
      } else {
        await FavoriteButton(productId.toString(), getToken);
        setIsFavorite(true);
        setFavoriteCount((count:any) => count + 1);
        updateDataLayer(productId);
      }
    } catch (error) {
      console.error("Error updating favorite status", error);
    }
  }, [getToken, router, isFavorite, productId]);

  // Format the price to the specified number of decimal places and return as a number
  const formatPrice = (price: number, digits: number = 2): number =>
    parseFloat(price.toFixed(digits));

  const updateDataLayer = (productId: number) => {
    if (!productItems || !Array.isArray(productItems)) {
      if (!isProduction) {
        console.error("Items array is not defined or not an array.");
      }
      return;
    }

    const filteredData = productItems.filter(
      (item: any) => item.item_id === productId
    );

    if (filteredData.length === 0) {
      if (!isProduction) {
        console.warn("No matching product found for favorite.");
      }
      return;
    }

    const productItem = filteredData.map((item: any) => item);

    const totalValue = productItem.reduce(
      (total, item) => total + (item.price || 0) * (item.quantity || 1),
      0
    );

    if (productItem.length > 0) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: "add_to_wishlist",
        ecommerce: {
          currency: "THB",
          value: formatPrice(totalValue),
          items: productItem,
        },
      });

      if (!isProduction) {
        console.log("DataLayer updated:", {
          event: "add_to_wishlist",
          ecommerce: {
            currency: "THB",
            value: formatPrice(totalValue),
            items: productItem,
          },
        });
      }
    }
  };

  const { isLoggedIn } = checkLoginStatus();

  useEffect(()=> {
    if (isLoggedIn) {
      GetProductFavorite()
    }
  }, [isFavorite])

  return (
    <div>
      <Stack
        direction={"row"}
        alignItems="center" // จัดเรียงแนวตั้งให้อยู่กึ่งกลาง
        justifyContent="center" // จัดเรียงแนวนอนให้อยู่กึ่งกลาง
      >
        <Checkbox
          checked={isFavorite}
          color="error"
          icon={<FavoriteBorder />}
          checkedIcon={<Favorite />}
          onChange={handleFavoriteToggle}
        />
        <Typography variant="body2" color="text.secondary" hidden={textLabel}
        sx={{
          mr:"12px"
        }}
        >
          {favoriteCount === null ? "" : "ถูกใจ " + favoriteCount}
        </Typography>
      </Stack>

     
    </div>
  );
};

export default MyFavoriteButton;
